import type { ChangeEvent, InputHTMLAttributes } from 'react'

type Base = Omit<InputHTMLAttributes<HTMLInputElement>, 'onChange' | 'value'>

/**
 * onChange takes the VALUE, matching the existing call sites that pass a setter directly.
 */
export function Input({
  value,
  onChange,
  onChangeEvent,
  className,
  ...rest
}: {
  readonly value: string
  readonly onChange?: (value: string) => void
  readonly onChangeEvent?: (event: ChangeEvent<HTMLInputElement>) => void
} & Base) {
  return (
    <input
      className={['ui-control', className ?? ''].filter((c) => c !== '').join(' ')}
      value={value}
      onChange={(event) => {
        onChange?.(event.target.value)
        onChangeEvent?.(event)
      }}
      {...rest}
    />
  )
}
